export enum SidebarTypes {
  General,
  Watchlist,
  SummaryInvested,
  BlockedBalance,
  SummaryWithdrawl,
  SubscriptionsList,
  EventsProvisionedList
}
